import React, { useState } from "react";
import GrGovTab from "./GrGovTabComponent";
import GrGovTabArea from "./GrGovTabAreaComponent";
import GrGovTabs from "./GrGovTabsComponent";

const GovGrTabs = ({
  inputTable = [
    { tabName: "Καρτέλα Α", component: <>Area 1</> },
    { tabName: "Καρτέλα Β", component: <>Area 2</> },
    { tabName: "Καρτέλα Γ", component: <>Area 3</> },
  ],
}) => {
  const [isActiveTab, setIsActiveTab] = useState(0);
  const handleTabChange = (index) => {
    setIsActiveTab(index);
  };
  return (
    <>
      <GrGovTabs>
        {inputTable.map((label, index) => (
          <GrGovTab
            key={label.tabName}
            label={label.tabName}
            onClick={() => handleTabChange(index)}
            value={index}
            activeTab={isActiveTab}
          />
        ))}
      </GrGovTabs>

      {inputTable.map((tabAreaInput, index) => (
        <GrGovTabArea value={isActiveTab} index={index} key={index}>
          {tabAreaInput.component}
        </GrGovTabArea>
      ))}
    </>
  );
};

export default GovGrTabs;
